import { render, staticRenderFns } from "./CartStep3.vue?vue&type=template&id=74c5d2fc&scoped=true&"
import script from "./CartStep3.vue?vue&type=script&lang=js&"
export * from "./CartStep3.vue?vue&type=script&lang=js&"
import style0 from "./CartStep3.vue?vue&type=style&index=0&id=74c5d2fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c5d2fc",
  null
  
)

export default component.exports